/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  cancelBtn: {
    type: [String, Object, Function],
    "default": ""
  },
  confirmBtn: {
    type: [String, Object, Function],
    "default": ""
  },
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  destroyOnClose: {
    type: Boolean,
    "default": true
  },
  icon: {
    type: Function
  },
  placement: {
    type: String,
    "default": "top",
    validator: function validator(val) {
      return ["top", "left", "right", "bottom", "top-left", "top-right", "bottom-left", "bottom-right", "left-top", "left-bottom", "right-top", "right-bottom"].includes(val);
    }
  },
  popupProps: {
    type: Object
  },
  showArrow: {
    type: Boolean,
    "default": true
  },
  theme: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      return ["default", "warning", "danger"].includes(val);
    }
  },
  triggerElement: {
    type: [String, Function]
  },
  visible: Boolean,
  defaultVisible: Boolean,
  onCancel: Function,
  onConfirm: Function,
  onVisibleChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/popconfirm/props.js
// module id = null
// module chunks = 